import ButtonCinestar from 'components/Buttons/ButtonCinestar/ButtonCinestar'
import Typography from 'components/Typography/Typography'
import { useLocation } from 'react-router'
import './EmptyBasket.scss'
import hocEmptyBasket from './hocEmptyBasket'

function EmptyBasket({ basket, basketRelease, reInitGiftVoucherBasket }) {
    //Find if there is ticket or meal voucher or card in the basket
    const isBasketEmpty = basket?.items_cards.length === 0 && basket?.items_tickets.length === 0
    const { search } = useLocation()
    const params = new URLSearchParams(search)
    const paramsObject = Object.fromEntries(params)
    const voucherid = paramsObject.voucherid
    const referer = paramsObject.ref
    const basketCinemaId = basket?.cinemaid
    const siteCinemaId = localStorage.getItem('cinemaid')
    const sameCinema = `${basketCinemaId}` === `${siteCinemaId}` || `${basketCinemaId}` === '0'

    if (!basket || (isBasketEmpty && sameCinema)) {
        return
    }

    return (
        <div className="empty-basket-modal">
            <div className="modal-content">
                <Typography variant="h2">Vysypat košík?</Typography>
                <Typography variant="p">
                    V košíku už máte nějaké položky, které brání nákupu. Chcete stávající košík vysypat?
                </Typography>
                <div className="mt-5 d-flex gap-2 justify-content-center">
                    <ButtonCinestar onClick={() => (window.location.href = referer)} variant={'secondary'}>
                        Zpět
                    </ButtonCinestar>
                    <ButtonCinestar onClick={() => reInitGiftVoucherBasket(voucherid)} variant={'secondary'}>
                        Vysypat
                    </ButtonCinestar>
                </div>
            </div>
        </div>
    )
}

export default hocEmptyBasket(EmptyBasket)
